import { AntragsummerGenerated } from '../action-types/antragsummerGenerated';
import { VhvAction, VhvActions } from '../vhvActions';
import { IAppState } from '../appState';

export const antragsnummerReducer = function (
  sectionState: string = null,
  action: VhvAction<AntragsummerGenerated>,
  state: IAppState,
): string {
  if (
    action.type === VhvActions.ANTRAGSNUMMER_GENERATED &&
    action.payload.angebotsId === state.angebotsId
  ) {
    return action.payload.antragsnummer;
  }
  return sectionState;
};
